module.exports = __webpack_public_path__ + "img/step4.9339170f.png";